import Image from "next/image";
import Link from "next/link";
import React from "react";

import { ComparedModel } from "app/compare/[match]";
import { Button } from "ui/Button";
import { applyCDNToUrl } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

type Props = {
  product: ComparedModel["product"];
};

const displayPrice = (price?: number) => {
  return price
    ? (price / 100)
        .toLocaleString("fr-FR", {
          style: "currency",
          currency: "EUR",
        })
        .replace(",00", "")
    : "-";
};

export const ProductCard = ({ product }: Props) => {
  const i18n = useI18n();

  if (!product) {
    return <div className="flex flex-col gap-5 justify-center items-center w-1/2">
      <Image src="/images/comparator/no-found-product.webp" alt="compare" width={140} height={140} />
      <p className="text-2xl text-center text-black/30">{i18n.t("comparator.productNotFound", {}, {html: true})}</p>
    </div>;
  }
  
  return (
    <div className="flex flex-col gap-5 items-center w-1/2">
      <Image
        src={applyCDNToUrl(product?.picture.medium) ?? ""}
        alt="compare"
        width={255}
        height={343}
      />
      <div className="flex flex-col items-center">
        <p className="text-lg text-center sm:text-2xl">
          {i18n.t("comparator.priceFrom")}
        </p>
        <p className="text-lg text-center sm:text-2xl">
          <span className="font-black">
            {displayPrice(product?.minimumSubscriptionPrice)}
          </span>{" "}
          {i18n.t("comparator.pricePerMonth")}
        </p>
        <p className="text-sm text-center sm:text-lg">
          <span className="font-bold">
            {displayPrice(product?.minimumUpfrontPrice)}
          </span>{" "}
          {i18n.t("comparator.priceUpfront")}
        </p>
      </div>
      <Link href={`/smartphone${product?.slug}`}>
        <a>
          <Button className="self-center mb-1 w-fit">
            <span className="sm:hidden">
              {i18n.t("comparator.chooseMobile")}
            </span>
            <span className="hidden sm:block">
              {i18n.t("comparator.chooseDesktop")}
            </span>
          </Button>
        </a>
      </Link>
    </div>
  );
};
